import { render, staticRenderFns } from "./modal-delete-team.vue?vue&type=template&id=5b437ceb&scoped=true&"
import script from "./modal-delete-team.vue?vue&type=script&lang=js&"
export * from "./modal-delete-team.vue?vue&type=script&lang=js&"
import style0 from "./modal-delete-team.vue?vue&type=style&index=0&id=5b437ceb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b437ceb",
  null
  
)

export default component.exports